import { Card, CardContent, Typography, Box, Chip } from "@mui/material";
import VisaIcon from "../../assets/image/svg/payment/visa.svg";
import AmexIcon from "../../assets/image/svg/payment/amex.svg";
import DiscoverIcon from "../../assets/image/svg/payment/discover.svg";
import MastercardIcon from "../../assets/image/svg/payment/mastercard.svg";

const brandIcons = {
  visa: VisaIcon,
  MasterCard: MastercardIcon,
  "American Express": AmexIcon,
  Discover: DiscoverIcon,
};

export function CreditCard({ pm, selected = false, onSelect }) {
 if (!pm || pm.type !== "card") return null;
  const card = pm.card || {};
  const holder = pm.billing_details || {};
  const last4 = card.last4 || "----";
  const brand = card.brand || "Card";
  const Icon = brandIcons[brand] || null;
  const expMonth = card.exp_month || "--";
  const expYear = card.exp_year || "--";

  return (
    <Card
      elevation={selected ? 8 : 3}
      onClick={() => onSelect && onSelect(pm)}
      sx={{
        width: '100%',
        height: 'auto',
        cursor: onSelect ? "pointer" : "default",
        borderRadius: 3,
        position: "relative",
        background: selected
          ? "linear-gradient(135deg, #ECFDF5, #FFFFFF)"
          : "linear-gradient(135deg, #FFFFFF, #F7F7F7)",
        p: 2,
        transition: "box-shadow .15s ease, transform .15s ease",
        "&:hover": {
          boxShadow: onSelect ? 6 : undefined,
          transform: onSelect ? "translateY(-2px)" : undefined,
        },
        border: selected ? "2px solid #10B981" : "1px solid #E5E7EB",
      }}
    >
      <CardContent sx={{ p: 0, '&:last-child': { p: 0 }, display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'space-between' }}>
        <Box display="flex" justifyContent="space-between" mb={'calc(var(--sp-md2)*1.5094339)'}>
          <Box display="flex" alignItems="center" gap={'calc(var(--sp-md2)*1.5094339)'}>
            <Box
              sx={{
                width: 'calc(var(--fs-hero)*1.132075)',
                height: 'calc(var(--fs-hero)*1.132075)',
                borderRadius: "50%",
                background: 'linear-gradient(225deg, #168DFB 0%, #161FFB 100%)',
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 'calc(var(--fs-xs)*1.8867924)',
                objectFit: 'contain',
              }}
            >
              {Icon ? (
                <img src={Icon} alt={brand} style={{ height: 'calc(var(--fs-hero)*1.0)',width: 'calc(var(--fs-hero)*1.0)', objectFit: 'contain' }} />
              ) : (
                "💳"
              )}
            </Box>

            <Box>
              <Typography variant="h6" fontWeight={600} sx={{ lineHeight: 1.2, fontSize:'calc(var(--fs-xs)*1.8867924)' }}>
                {brand.toUpperCase()}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontSize:'calc(var(--fs-xs)*1.3207547)' }}>
                {holder.name || "Card Holder"}
              </Typography>
            </Box>
          </Box>

          <Chip
            label="Card"
            color="info"
            variant="outlined"
            size="small"
            sx={{ textTransform: "capitalize", marginLeft: 'calc(var(--sp-lg))', fontSize:'calc(var(--fs-xs)*1.226415)',padding:'var(--sp-md2)', borderRadius:'calc(var(--sp-md2)*1.5094339)' }}
          />
        </Box>

        <Box mt={1}>
          <Typography variant="caption" color="text.secondary" sx={{ fontSize:'calc(var(--fs-xs)*1.132075)' }}>
            Card Number
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "calc(var(--sp-md2)*1.1320754)",
              mt: "calc(var(--sp-xxs)*2)",
              fontSize: "calc(var(--fs-xs)*1.8867924)",
              fontWeight: 600,
              letterSpacing: "calc(var(--sp-xxs)*0.5)",
              fontFamily: "Poppins, sans-serif",
            }}
          >
            <span>****</span>
            <span>****</span>
            <span>****</span>
            <span>{last4}</span>
          </Box>
        </Box>

        <Box
          display="flex"
          justifyContent="space-between"
          mt={'calc(var(--sp-md2)*1.5094339)'}
          sx={{ color: "text.secondary", fontSize: 'calc(var(--fs-xs)*1.132075)' }}
        >
          <Typography variant="body2" sx={{ fontSize:'calc(var(--fs-xs)*1.3207547)' }}>
            Exp: {expMonth}/{expYear}
          </Typography>

          {selected && (
            <Chip
              label="Default"
              size="small"
              variant="outlined"
              sx={{
                borderColor: "#10B981",
                color: "#10B981",
                fontWeight: 600,
                backgroundColor: "#FFFFFF",
                fontSize:'calc(var(--fs-xs)*1.226415)',padding:'var(--sp-md2)', borderRadius:'calc(var(--sp-md2)*1.5094339)'
              }}
            />
        )}
        </Box>        
      </CardContent>
    </Card>
  );
};
